import React from "react";

import { Box } from "../../layout";

type Props = {
  children: React.ReactNode;
};

export default function ModalContainer({ children }: Props) {
  return <Box position="relative">{children}</Box>;
}
